// extracted by mini-css-extract-plugin
module.exports = {"abbr":"abbr-1kKjy-5gS_"};